import {List} from 'immutable';
import * as moment from 'moment';

import {IDischargeCurveSettings} from '../../discharge/curve.controller';
import {IDischargeModel} from '../../api/api.types';
import {
    IDischargeChartPoint,
    IDischargeCurveFittingService,
    IFitDischargeModel
} from '../../discharge/discharge.types';
import {StationCreatorHQTableController} from './curve-hq-table.controller';
import {IDischargeModelItem} from '../../discharge/model-list/model-list.controller';
import {IChartColorService} from '../../utils/chart-color.service';

const hqTableTemplate = require<string>('./curve-hq-table.html');

interface IStationCurveScope extends ng.IScope {
  waterLevelForm:ng.IFormController;
  dischargeForm:ng.IFormController;
  modelForm:ng.IFormController;
}

export default class StationCreatorCurveController {
  static $inject = ['$scope', '$mdDialog', 'dischargeCurveFittingService'];

  private minWaterLevel:number;
  private maxWaterLevel:number;

  newDischargePoint:IDischargeChartPoint;

  dischargeModelItems:List<IDischargeModelItem>;
  dischargeData:List<IDischargeChartPoint>;
  dischargeDataArray:Array<IDischargeChartPoint>;
  modelName:string;
  onChange:(callbackArgs:{
    dischargeModel:IDischargeModel,
    isValid:boolean}) => void;

  constructor(private $scope:IStationCurveScope,
              private $mdDialog:ng.material.IDialogService,
              private dischargeCurveFittingService:IDischargeCurveFittingService) {
    this.dischargeData = List<IDischargeChartPoint>();
    this.newDischargePoint = {
      discharge: null,
      waterLevel: null
    };
    this.dischargeModelItems = List<IDischargeModelItem>();
  }

  get mutableDischargeModel():IDischargeModel {
    return this.dischargeModelItems.size > 0
        ? this.dischargeModelItems.first().dischargeModel
        : null;
  }

  addDischargePoint() {
    this.dischargeData = this.dischargeData.push(this.newDischargePoint);
    this.dischargeDataArray = this.dischargeData.toArray();
    this.newDischargePoint = {
      discharge: null,
      waterLevel: null
    };
    this.$scope.waterLevelForm.$setPristine();
    this.$scope.dischargeForm.$setPristine();
    this.$scope.waterLevelForm.$setUntouched();
    this.$scope.dischargeForm.$setUntouched();
    if (this.dischargeData.size > 1) {
      this.fitNewModel();
    }
    this.notifyChange();
  }

  deleteDischargePoint(index:number) {
    this.dischargeData = this.dischargeData.remove(index);
    this.dischargeDataArray = this.dischargeData.toArray();
    this.dischargeModelItems = this.dischargeModelItems.clear();
    if (this.dischargeData.size > 1) {
      this.fitNewModel();
    }
    this.notifyChange();
  }

  onChartBoundsChanged(curveSettings:IDischargeCurveSettings, userChange:boolean) {
    this.minWaterLevel = curveSettings.minWaterLevel;
    this.maxWaterLevel = curveSettings.maxWaterLevel;
  };

  onModelNameChange() {
    if (this.mutableDischargeModel) {
      this.mutableDischargeModel.modelName = this.modelName;
      this.notifyChange();
    }
  }

  showHQTable = ($event:MouseEvent) => {
    this.$mdDialog.show({
      targetEvent: $event,
      controller: StationCreatorHQTableController,
      controllerAs: '$ctrl',
      bindToController: true,
      locals: {
        dischargeModel: this.mutableDischargeModel,
        minWaterLevel: this.minWaterLevel,
        maxWaterLevel: this.maxWaterLevel
      },
      template: hqTableTemplate
    });
  };

  private fitNewModel() {
    this.dischargeModelItems = List.of({
      dischargeModel: StationCreatorCurveController.toDischargeModel(
          this.dischargeCurveFittingService
              .fitCurveQuadraticMethod(this.dischargeDataArray)),
      colors: IChartColorService.BLACK_COLORS,
      enabled: true
    });
    this.mutableDischargeModel.modelName = this.modelName;
  }

  private notifyChange() {
    const isValidModel = this.mutableDischargeModel &&
        this.mutableDischargeModel.modelName != null;
    this.onChange({
      dischargeModel: this.mutableDischargeModel,
      isValid: isValidModel
    })
  }

  private static toDischargeModel(fitModel:IFitDischargeModel):IDischargeModel {
    return {
      id: 0,
      modelName: '',
      paramA: fitModel.paramA,
      paramB: fitModel.paramB,
      paramC: fitModel.paramC,
      paramDeltaLevel: fitModel.paramDeltaLevel,
      validFrom: null
    };
  }
}



/** WEBPACK FOOTER **
 ** ./app/station/creator/curve.controller.ts
 **/